module.exports = __webpack_public_path__ + "static/assets/f3c3f7af69992cded551363e451e29a6.svg";